import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../Input/Button/Button';

import './PageNav.scss';

/**
 * Nav component for selecting content
 */
export default class PageNav extends React.Component {
    static propTypes = {
        /**
         * url to go to previous job results
         */
        prevPage: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
        /**
         * url to go to next job results
         */
        nextPage: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    };

    static defaultProps = {
        prevUrl: null,
        nextUrl: null,
        metricOnClick: () => {},
    };

    renderBtn(value, onClick) {
        const disabled = onClick === null;

        const button = (
            <div className="page-btn d-inline-block">
                <Button disabled={disabled} type="wired" value={value} />
            </div>
        );

        const anchorProps = {};
        if (typeof onClick === 'string') {
            anchorProps.href = onClick;
            anchorProps.onClick = this.props.metricOnClick;
        } else {
            anchorProps.onClick = onClick;
        }

        return (
            <div className="page-btn d-inline-block">
                <a {...anchorProps}>{button}</a>
            </div>
        );
    }

    render() {
        return (
            <div className="component-pagination-PageNav">
                {this.renderBtn('Prev', this.props.prevUrl)}
                {this.renderBtn('Next', this.props.nextUrl)}
            </div>
        );
    }
}
